import styled from 'styled-components';

import { TextEllipsis } from 'components/App/GlobalStyled';

const Wrap = styled.div`
  position: relative;
`;

const Container = styled.div`
  display: inline-block;
  ${({ $width }) => TextEllipsis({ width: `${$width || 150}px` })};
  padding-left: 2px;
  cursor: pointer;
  color: ${({ theme }) => theme.gray950};

  &:hover {
    text-decoration: underline;
  }
`;

export { Wrap, Container };
